import { render } from "./GerenciarPenalidades.vue?vue&type=template&id=e86b6c6c"
import script from "./GerenciarPenalidades.vue?vue&type=script&lang=js"
export * from "./GerenciarPenalidades.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__